import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=0dec8124"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports